/// <reference path="../../../tools/typings/angularjs/angular.d.ts"/>

module DealerwareWebComponents {
    "use strict";

    export class StateSelectDirectiveController {
        public static $inject: string[] = [
            '$scope',
            '$filter'
        ];

        public states: any;
        public countries: any;
        public required: boolean = false;
        public readOnly: boolean;
        public forCountry: any;
        public selectedState: any;

        constructor(public $scope: any,
                    public $filter: any) {
            var _self = this,
                countries_with_states = [
                    { code: 'US', name: 'United States and Territories' },
                    { code: 'CA', name: 'Canada' }
                ];

            this.states = [
                // United States and Territories
                { country: 'US', code: 'AL', name: 'Alabama' },
                { country: 'US', code: 'AK', name: 'Alaska' },
                { country: 'US', code: 'AS', name: 'American Samoa' },
                { country: 'US', code: 'AZ', name: 'Arizona' },
                { country: 'US', code: 'AR', name: 'Arkansas' },
                { country: 'US', code: 'CA', name: 'California' },
                { country: 'US', code: 'CO', name: 'Colorado' },
                { country: 'US', code: 'CT', name: 'Connecticut' },
                { country: 'US', code: 'DE', name: 'Delaware' },
                { country: 'US', code: 'DC', name: 'District Of Columbia' },
                { country: 'US', code: 'FM', name: 'Federated States Of Micronesia' },
                { country: 'US', code: 'FL', name: 'Florida' },
                { country: 'US', code: 'GA', name: 'Georgia' },
                { country: 'US', code: 'GU', name: 'Guam' },
                { country: 'US', code: 'HI', name: 'Hawaii' },
                { country: 'US', code: 'ID', name: 'Idaho' },
                { country: 'US', code: 'IL', name: 'Illinois' },
                { country: 'US', code: 'IN', name: 'Indiana' },
                { country: 'US', code: 'IA', name: 'Iowa' },
                { country: 'US', code: 'KS', name: 'Kansas' },
                { country: 'US', code: 'KY', name: 'Kentucky' },
                { country: 'US', code: 'LA', name: 'Louisiana' },
                { country: 'US', code: 'ME', name: 'Maine' },
                { country: 'US', code: 'MH', name: 'Marshall Islands' },
                { country: 'US', code: 'MD', name: 'Maryland' },
                { country: 'US', code: 'MA', name: 'Massachusetts' },
                { country: 'US', code: 'MI', name: 'Michigan' },
                { country: 'US', code: 'MN', name: 'Minnesota' },
                { country: 'US', code: 'MS', name: 'Mississippi' },
                { country: 'US', code: 'MO', name: 'Missouri' },
                { country: 'US', code: 'MT', name: 'Montana' },
                { country: 'US', code: 'NE', name: 'Nebraska' },
                { country: 'US', code: 'NV', name: 'Nevada' },
                { country: 'US', code: 'NH', name: 'New Hampshire' },
                { country: 'US', code: 'NJ', name: 'New Jersey' },
                { country: 'US', code: 'NM', name: 'New Mexico' },
                { country: 'US', code: 'NY', name: 'New York' },
                { country: 'US', code: 'NC', name: 'North Carolina' },
                { country: 'US', code: 'ND', name: 'North Dakota' },
                { country: 'US', code: 'MP', name: 'Northern Mariana Islands' },
                { country: 'US', code: 'OH', name: 'Ohio' },
                { country: 'US', code: 'OK', name: 'Oklahoma' },
                { country: 'US', code: 'OR', name: 'Oregon' },
                { country: 'US', code: 'PW', name: 'Palau' },
                { country: 'US', code: 'PA', name: 'Pennsylvania' },
                { country: 'US', code: 'PR', name: 'Puerto Rico' },
                { country: 'US', code: 'RI', name: 'Rhode Island' },
                { country: 'US', code: 'SC', name: 'South Carolina' },
                { country: 'US', code: 'SD', name: 'South Dakota' },
                { country: 'US', code: 'TN', name: 'Tennessee' },
                { country: 'US', code: 'TX', name: 'Texas' },
                { country: 'US', code: 'UT', name: 'Utah' },
                { country: 'US', code: 'VT', name: 'Vermont' },
                { country: 'US', code: 'VI', name: 'Virgin Islands' },
                { country: 'US', code: 'VA', name: 'Virginia' },
                { country: 'US', code: 'WA', name: 'Washington' },
                { country: 'US', code: 'WV', name: 'West Virginia' },
                { country: 'US', code: 'WI', name: 'Wisconsin' },
                { country: 'US', code: 'WY', name: 'Wyoming' },
                { country: 'US', code: 'AA', name: 'Armed Forces Americas' },
                { country: 'US', code: 'AE', name: 'Armed Forces Europe' },
                { country: 'US', code: 'AP', name: 'Armed Forces Pacific' },
                // Canada
                { country: 'CA', code: 'AB', name: 'Alberta' },
                { country: 'CA', code: 'BC', name: 'British Columbia' },
                { country: 'CA', code: 'MB', name: 'Manitoba' },
                { country: 'CA', code: 'NB', name: 'New Brunswick' },
                { country: 'CA', code: 'NL', name: 'Newfoundland and Labrador' },
                { country: 'CA', code: 'NT', name: 'Northwest Territories' },
                { country: 'CA', code: 'NS', name: 'Nova Scotia' },
                { country: 'CA', code: 'NU', name: 'Nunavut' },
                { country: 'CA', code: 'ON', name: 'Ontario' },
                { country: 'CA', code: 'PE', name: 'Prince Edward Island' },
                { country: 'CA', code: 'QC', name: 'Quebec' },
                { country: 'CA', code: 'SK', name: 'Saskatchewan' },
                { country: 'CA', code: 'YT', name: 'Yukon' }
            ];

            this.$scope.$watch(() => {
                return _self.forCountry;
            }, (country: any) => {
                if (country) {
                    _self.countries = _self.$filter('filter')(countries_with_states, function(rec: any) {
                        return rec.code === country;
                    });
                } else {
                    _self.countries = countries_with_states;
                }
            });
        }
    }

    getDealerwareWebComponentsModule().controller('StateSelectDirectiveController', StateSelectDirectiveController);

    export class StateSelectDirective implements ng.IDirective {
        public restrict         : string    =   'E';
        public controller       : any       =   'StateSelectDirectiveController';
        public controllerAs     : string    =   'stateSelectController';
        public bindToController : boolean   =   true;
        public replace          : boolean   =   false;
        public scope            : Object    =   {
            required: '=?',
            forCountry: '=?',
            readOnly: '=',
            selectedState: '='
        };
        public transclude       : boolean   =   false;
        public templateUrl      : string    =   '/components/state_select/state_select_directive.html';
        public static $inject   : string[]  =   [];

        constructor() {}

        public link : ng.IDirectiveLinkFn = (
            scope   :   ng.IScope,
            element :   ng.IAugmentedJQuery,
            attrs   :   ng.IAttributes,
            ctrls   :   any
        ) => {}
    }

    getDealerwareWebComponentsModule().directive("dealerwareStateSelect",() => new StateSelectDirective());
 }